"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationContainer = void 0;
const react_hooks_1 = require("@apollo/react-hooks");
const ConversationModel_1 = __importDefault(require("@opsbase/lib-data-model/models/ConversationModel"));
const ConversationController_1 = __importStar(require("@opsbase/react-ctrl-conversation/ConversationController"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const react_1 = __importDefault(require("react"));
const ConversationView_1 = require("./ConversationView");
function ConversationContainer({ id, title, onConversationCreated, invertLayout, simpleCallouts, relatedOpId, relatedIssueId, editable, supportedTimelineStates = [
    ConversationController_1.TimelineViewState.MessagesOnly,
    ConversationController_1.TimelineViewState.MessagesAndActivity,
], placeholderText, activity, }) {
    const self = (0, useSelf_1.default)();
    const client = (0, react_hooks_1.useApolloClient)();
    return (react_1.default.createElement(ConversationController_1.default, { conversationId: id, title: title, onCreateConversation: onConversationCreated, invertLayout: invertLayout, simpleCallouts: simpleCallouts, relatedOpId: relatedOpId, relatedIssueId: relatedIssueId, editable: editable, defaultConversation: !id ? new ConversationModel_1.default({ title }) : null, supportedTimelineStates: supportedTimelineStates, placeholderText: placeholderText, activity: activity, self: self, client: client },
        react_1.default.createElement(ConversationView_1.ConversationView, null)));
}
exports.ConversationContainer = ConversationContainer;
exports.default = ConversationContainer;
